const routes = {
  createUser: 'users/add',
  getUsers: 'users',
  updateUser: 'users/update',
  updateUserStatus: 'users/disable',
  getUserPermissions: 'users/permissions',
  updateMobilePermission: 'customers/mobile/permission',
  getMobilePermissions: 'customers/mobile/permission',
  updateExecAppPermission: 'customers/exec-app/permission',
  getExecAppPermissions: 'customers/exec-app/permission',
  getRelationshipManager: 'users/relationship-manager',
};

export default routes